import { render, staticRenderFns } from "./contrato.vue?vue&type=template&id=bbddfb7c&scoped=true"
import script from "./contrato.vue?vue&type=script&lang=js"
export * from "./contrato.vue?vue&type=script&lang=js"
import style0 from "./contrato.vue?vue&type=style&index=0&id=bbddfb7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbddfb7c",
  null
  
)

export default component.exports